<div [ngSwitch]="buttontype?.type" class="custom-button">
    <button class="custom-button__confirm" [ngClass]="buttontype.customclass" #dynamicbutton *ngSwitchCase="'confirm'"
        [disabled]='buttontype.disbaledproperity' mat-raised-button (click)="handleclick($event)"><i class="btn-icon"
            [ngClass]="buttontype.icon"></i>
        <span>{{ buttontype.label | translate }}</span></button>

    <button class="custom-button__cancel" [ngClass]="buttontype.customclass" #dynamicbutton *ngSwitchCase="'cancel'"
        [disabled]='buttontype.disbaledproperity' mat-raised-button (click)="handleclick($event)"><i class="btn-icon"
            [ngClass]="buttontype.icon"></i> {{ buttontype.label | translate }}</button>


    <button class="custom-button__option default-form-field" [ngClass]="buttontype.customclass" #dynamicbutton
        *ngSwitchCase="'option'" [disabled]='buttontype.disbaledproperity' mat-raised-button
        (click)="handleclick($event)"><i class="btn-icon" [ngClass]="buttontype.icon"></i> {{ buttontype.label |
        translate }}</button>
    <button class="primary-orange action-primary" [ngClass]="buttontype.customclass" #dynamicbutton
        *ngSwitchCase="'action-primary'" [disabled]='buttontype.disbaledproperity' mat-raised-button
        (click)="handleclick($event)"><i class="btn-icon" [ngClass]="buttontype.icon"></i> {{ buttontype.label |
        translate }}
        <span class="d-block rs-Roboto-Regular-10" *ngIf="buttontype.additionalText">{{buttontype.additionalText |
            translate}}</span></button>


    <button class="secondary action-secondary" [ngClass]="buttontype.customclass" #dynamicbutton
        [ngStyle]="buttontype.customStyle" *ngSwitchCase="'action-secondary'" [disabled]='buttontype.disbaledproperity'
        mat-raised-button (click)="handleclick($event)"><i class="btn-icon" [ngClass]="buttontype.icon"></i> {{
        buttontype.label |
        translate }}
        <span class="d-block rs-Roboto-Regular-10" *ngIf="buttontype.additionalText">{{buttontype.additionalText |
            translate}}</span></button>


</div>